import {Box, Card, Stack, Typography, styled} from '@mui/material';
import {TagChip} from 'presentation/components';

const StyledCard = styled(Card)`
	position: relative;
	min-height: 222px;
	width: 384px;
	display: flex;
	flex-direction: column;
	background-color: white;

	${({theme}) => theme.breakpoints.down('sm')} {
		width: 328px;
	}
`;

const StyledBox = styled(Box)`
	padding: 16px;
	background-color: ${({theme}) => theme.palette.background.paper};
	flex: 1;

	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

const StyledCardHeader = styled(Box)`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: 12px;
	min-height: 0;
`;

const StyledHeaderLeftColumn = styled(Stack)`
	gap: 8px;
`;

const StyledHeaderTopRow = styled(Box)`
	display: flex;
	width: 100%;
`;

const StyledPartnerLogoWrapper = styled(Box)`
	display: flex;
	align-self: flex-start;
	justify-content: flex-end;
	max-width: 73px;
	width: 100%;

	img {
		display: block;
		max-width: 100%;
		height: auto;
		object-fit: contain;
	}
`;

const StyledSubtitle = styled(Typography)`
	color: ${({theme}) => theme.brand.primary.blue};
	font-size: 0.75rem;
	line-height: 90%;
	letter-spacing: 0.1px;
`;

const StyledTitle = styled(Typography)`
	color: ${({theme}) => theme.brand.primary.blue};
	font-size: 1rem;
	line-height: 1.1;
	font-weight: 600;
	text-transform: uppercase;
	white-space: normal;
	overflow-wrap: anywhere;
	max-width: 100%;
`;

const StyledText = styled(Typography)`
	color: ${({theme}) => theme.palette.text.primary};
	font-family: 'Source Code Pro';
	line-height: 1.4;
	letter-spacing: 0.17px;
	text-transform: uppercase;
	font-size: 0.875rem;
`;

const StyledChip = styled(TagChip)`
	position: absolute;
	background-color: ${({theme}) => theme.colors.light.action.selected};
	bottom: 10px;
	right: 16px;
`;

export {
	StyledCard,
	StyledCardHeader,
	StyledHeaderLeftColumn,
	StyledHeaderTopRow,
	StyledBox,
	StyledSubtitle,
	StyledTitle,
	StyledPartnerLogoWrapper,
	StyledText,
	StyledChip,
};
